import { useEffect, useState } from 'react';

import * as styles from './WineProvider.module.css';
import a from './a.png';
import d from './d.png';
import j from './j.png';
import q from './q.png';

export const WineProvider: React.FC = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    setIsEnabled(window.location.hostname.startsWith('moi.'));
  }, []);

  return isEnabled ? (
    <div className={styles.view}>
      <div className={styles.top}>
        <img src={a} alt='' className={styles.a} />
        <img src={j} alt='' className={styles.j} />
        <img src={d} alt='' className={styles.d} />
        <img src={q} alt='' className={styles.q} />
        <div className={styles.bottleWrapper}>
          <svg
            className={styles.bottle}
            width='251'
            height='1548'
            viewBox='0 0 251 1548'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              className={styles.pouring}
              d='M94 1548L94 200.388C94 173.838 103.863 148.234 121.676 128.547L129.604 119.784'
              stroke='#8C0032'
              strokeWidth='11.2434'
            />
            <mask
              id='mask0_4_290'
              style={{ maskType: 'alpha' }}
              maskUnits='userSpaceOnUse'
              x='106'
              y='0'
              width='145'
              height='146'
            >
              <path
                d='M119.178 143.771C122.409 146.936 127.686 146.54 130.409 142.928L131.621 141.32C132.01 140.804 132.464 140.34 132.972 139.941L134.555 138.696C136.699 137.009 137.654 134.418 137.366 131.933L177.424 96.1958C190.923 100.869 206.542 97.4751 216.852 86.2161L250.55 49.4171L200.105 0L164.007 34.4491C152.963 44.989 149.892 60.6744 154.842 74.0744L119.782 115.041C117.408 114.932 115.007 115.945 113.446 118.017L112.234 119.625C111.845 120.141 111.39 120.604 110.883 121.004L109.3 122.249C105.745 125.046 105.458 130.33 108.689 133.495L119.178 143.771Z'
                fill='#125B11'
              />
            </mask>
            <g mask='url(#mask0_4_290)'>
              <path
                d='M119.178 143.771C122.409 146.936 127.686 146.54 130.409 142.928L131.621 141.32C132.01 140.804 132.464 140.34 132.972 139.941L134.555 138.696C136.699 137.009 137.654 134.418 137.366 131.933L177.424 96.1958C190.923 100.869 206.542 97.4751 216.852 86.2161L250.55 49.4171L200.105 0L164.007 34.4491C152.963 44.989 149.892 60.6744 154.842 74.0744L119.782 115.041C117.408 114.932 115.007 115.945 113.446 118.017L112.234 119.625C111.845 120.141 111.39 120.604 110.883 121.004L109.3 122.249C105.745 125.046 105.458 130.33 108.689 133.495L119.178 143.771Z'
                fill='#125B11'
              />
              <rect
                x='176.011'
                y='48.5851'
                width='23.7369'
                height='52.5179'
                transform='rotate(-133.655 176.011 48.5851)'
                fill='#D8D8D8'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M122.501 142.769C119.709 146.115 114.662 146.384 111.531 143.353L107.938 139.873L240.883 37.1822L248.756 44.8051L215.274 81.8008C205.03 93.1199 189.431 96.605 175.905 92.011L136.4 127.673C135.982 128.696 135.33 129.644 134.444 130.433L128.43 135.789C128.154 136.035 127.896 136.301 127.659 136.585L122.501 142.769Z'
                fill='#014A00'
              />
            </g>
          </svg>

          <svg
            className={styles.splash}
            width='80'
            height='79'
            viewBox='0 0 80 79'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M47.412 0.198306C51.0252 0.923134 53.7943 3.50114 54.9286 6.74476C58.1575 5.56921 61.9062 6.08053 64.7548 8.41851C67.4721 10.6487 68.7189 14.0062 68.3739 17.2588C71.5985 17.807 74.4933 19.916 75.9048 23.1355C77.1193 25.9058 76.985 28.9267 75.7889 31.4633C77.903 33.3062 79.2389 36.019 79.2389 39.0438C79.2389 42.3783 77.6155 45.3335 75.1159 47.1623C76.5721 49.8958 76.7495 53.2629 75.3001 56.2658C73.7798 59.4155 70.8325 61.4131 67.6095 61.8571C67.8248 65.1035 66.4627 68.3932 63.6844 70.5175C61.2033 72.4145 58.1214 72.978 55.2995 72.3229C54.0081 74.9161 51.6114 76.9339 48.569 77.6393C45.5191 78.3465 42.4717 77.584 40.1688 75.8147C37.9198 77.652 34.8965 78.5052 31.8269 77.8894C28.2136 77.1646 25.4445 74.5866 24.3102 71.3429C21.0813 72.5185 17.3326 72.0072 14.484 69.6692C11.7667 67.439 10.5199 64.0815 10.8649 60.8289C7.64036 60.2807 4.7456 58.1717 3.33412 54.9522C2.11957 52.1819 2.25384 49.161 3.45 46.6243C1.33595 44.7814 0 42.0687 0 39.0438C0 35.7095 1.62338 32.7543 4.12288 30.9255C2.66677 28.192 2.48934 24.8249 3.93876 21.822C5.459 18.6723 8.40633 16.6746 11.6294 16.2307C11.4141 12.9843 12.7762 9.69464 15.5545 7.57035C18.0356 5.67333 21.1174 5.10978 23.9394 5.76488C25.2308 3.17168 27.6275 1.15387 30.6699 0.44838C33.7198 -0.258813 36.7673 0.503672 39.0701 2.273C41.3191 0.435703 44.3424 -0.417457 47.412 0.198306Z'
              fill='#8C0032'
              fillOpacity='0.7'
            />
          </svg>
          <svg
            className={styles.splash}
            width='80'
            height='79'
            viewBox='0 0 80 79'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M47.412 0.198306C51.0252 0.923134 53.7943 3.50114 54.9286 6.74476C58.1575 5.56921 61.9062 6.08053 64.7548 8.41851C67.4721 10.6487 68.7189 14.0062 68.3739 17.2588C71.5985 17.807 74.4933 19.916 75.9048 23.1355C77.1193 25.9058 76.985 28.9267 75.7889 31.4633C77.903 33.3062 79.2389 36.019 79.2389 39.0438C79.2389 42.3783 77.6155 45.3335 75.1159 47.1623C76.5721 49.8958 76.7495 53.2629 75.3001 56.2658C73.7798 59.4155 70.8325 61.4131 67.6095 61.8571C67.8248 65.1035 66.4627 68.3932 63.6844 70.5175C61.2033 72.4145 58.1214 72.978 55.2995 72.3229C54.0081 74.9161 51.6114 76.9339 48.569 77.6393C45.5191 78.3465 42.4717 77.584 40.1688 75.8147C37.9198 77.652 34.8965 78.5052 31.8269 77.8894C28.2136 77.1646 25.4445 74.5866 24.3102 71.3429C21.0813 72.5185 17.3326 72.0072 14.484 69.6692C11.7667 67.439 10.5199 64.0815 10.8649 60.8289C7.64036 60.2807 4.7456 58.1717 3.33412 54.9522C2.11957 52.1819 2.25384 49.161 3.45 46.6243C1.33595 44.7814 0 42.0687 0 39.0438C0 35.7095 1.62338 32.7543 4.12288 30.9255C2.66677 28.192 2.48934 24.8249 3.93876 21.822C5.459 18.6723 8.40633 16.6746 11.6294 16.2307C11.4141 12.9843 12.7762 9.69464 15.5545 7.57035C18.0356 5.67333 21.1174 5.10978 23.9394 5.76488C25.2308 3.17168 27.6275 1.15387 30.6699 0.44838C33.7198 -0.258813 36.7673 0.503672 39.0701 2.273C41.3191 0.435703 44.3424 -0.417457 47.412 0.198306Z'
              fill='#8C0032'
              fillOpacity='0.7'
            />
          </svg>
        </div>
      </div>
      <div className={styles.bottom}></div>
    </div>
  ) : (
    <></>
  );
};
